import React from 'react';
import PropTypes from 'prop-types';
/* Utils */
import { numberWithCommas } from 'client/site-modules/shared/utils/string';

import './offer-type-table-chart-price.scss';

export function OfferTypeTableChartPrice({ showLeasePayments = false, clearValue = '' }) {
  const inputValue = clearValue ? numberWithCommas(clearValue) : '';
  let width = clearValue > 99999 ? '100px' : '90px';

  if (showLeasePayments) {
    width = clearValue > 999 ? '110px' : '93px';
    width = clearValue > 9999 ? '120px' : width;
  }

  return (
    <div className="offer-type-table-chart-price">
      <div className="chart-price size-20 text-gray-darker ps-1_25 pe-0_5 py-0_5 fw-normal" style={{ width }}>
        {inputValue}
      </div>
      {showLeasePayments && !!inputValue && <div className="monthly-label heading-4 fw-normal">/mo.</div>}
    </div>
  );
}

OfferTypeTableChartPrice.propTypes = {
  clearValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showLeasePayments: PropTypes.bool,
};
